export const Vision2028Badge = () => {
  return (
    <span
      style={{
        fontSize: '0.65em',
        padding: '3px 6px',
        backgroundColor: 'rgba(74, 144, 226, 0.15)',
        color: '#4a90e2',
        borderRadius: '3px',
        fontWeight: 'normal',
        fontFamily: '기본체',
        display: 'inline-flex',
        alignItems: 'center',
        lineHeight: 1.2,
      }}
    >
      VISION 2028
    </span>
  );
};

